import axios, { AxiosInstance } from 'axios';
import variables from './variables';

const defaultOptions = {
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
};

// Sur 503, l'API est en maintenance : redirige vers /maintenance.
const attachMaintenanceInterceptor = (instance: AxiosInstance) => {
  instance.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error.response?.status === 503 && window.location.pathname !== '/maintenance') {
        window.location.href = '/maintenance';
      }
      return Promise.reject(error);
    },
  );
};

// ============================================
// Clients API pour les formulaires d'assurance
// ============================================

/** API DevisWS - Tarification & gestion de session */
export const requestWS = axios.create({
  baseURL: variables.WS_URL,
  ...defaultOptions,
});
attachMaintenanceInterceptor(requestWS);

/** API Services - Backend métier (adresses, SIREN, IBAN, lieu de naissance) */
export const requestServices = axios.create({
  baseURL: variables.SERVICES_URL,
  ...defaultOptions,
});
attachMaintenanceInterceptor(requestServices);

/** API Wheels - Véhiculier (marques, modèles, versions) */
export const requestWheels = axios.create({
  baseURL: variables.WHEELS_URL,
  ...defaultOptions,
});
attachMaintenanceInterceptor(requestWheels);

/** API Pass - Microservice polyvalent */
export const requestPass = axios.create({
  baseURL: variables.PASS_URL,
  ...defaultOptions,
});
attachMaintenanceInterceptor(requestPass);

// ============================================
// Clients API pour les autres applications
// ============================================

/** API Calendar - Réservation RDV (booking) */
export const requestCalendar = axios.create({
  baseURL: variables.CALENDAR_URL,
  ...defaultOptions,
  withCredentials: true,
});

// Intercepteur pour gérer les erreurs 401
requestCalendar.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      if (!window.location.pathname.includes('/auth/login')) {
        window.location.href = '/auth/login';
      }
    }
    return Promise.reject(error);
  },
);

/** API Deals - CRM devis et contacts (auth par cookie HttpOnly) */
export const requestDeals = axios.create({
  baseURL: variables.DEALS_URL,
  ...defaultOptions,
  withCredentials: true,
});

// Intercepteur pour gérer les erreurs 401
requestDeals.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      if (!window.location.pathname.includes('/auth/login')) {
        window.location.href = '/auth/login';
      }
    }
    return Promise.reject(error);
  },
);

/** API CMS - Backoffice CMS (auth par cookie session Laravel) */
export const requestCms = axios.create({
  baseURL: variables.CMS_URL,
  ...defaultOptions,
  withCredentials: true,
});

// Intercepteur pour gérer les erreurs 401
requestCms.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      if (!window.location.pathname.includes('/auth/login')) {
        window.location.href = '/auth/login';
      }
    }
    return Promise.reject(error);
  },
);

/** API Documents - Suivi des pièces justificatives (auth par clé d'URL) */
export const requestDocuments = axios.create({
  baseURL: variables.DOCUMENTS_URL,
  ...defaultOptions,
});
